import { useMemo } from 'react'
import { Row, Col } from 'react-bootstrap'
import { IntegrationServiceId } from '../../../../../../../common/integrations'
import { OutboundFieldMapping } from '../../OutboundMappingSettings/OutboundFieldMapping'
import { MentionData } from '../../../../../../../apps/professional-app/fa/MeetingSummary/MeetingResults/Lexical/Nodes/MentionNode/MentionNode'
import { ContactLinking } from '../../ContactLinking/ContactLinking'

interface CustomDocumentAdminSettingsProps {
  serviceId: IntegrationServiceId
  formKey?: number
  onChange?: () => void
}

export const CustomDocumentAdminSettings: React.FC<CustomDocumentAdminSettingsProps> = ({ serviceId, formKey = 0, onChange }) => {
  const documentFieldMappingInputTokenOptions: MentionData[] = useMemo(() => {
    return [
      { id: 'summary', label: 'Summary', metadata: { type: 'string' } },
      { id: 'summaryPlainText', label: 'Summary Plain Text', metadata: { type: 'string' } },
      { id: 'relatedToId', label: 'Related To Id', metadata: { type: 'string' } },
      { id: 'complianceMessage', label: 'Compliance Message', metadata: { type: 'string' } },
      { id: 'createdAt', label: 'Created At', metadata: { type: 'datetime' } },
    ]
  }, [])

  return (
    <>
      <Row className='mt-7'>
        <Col>
          <OutboundFieldMapping
            serviceId={serviceId}
            mappingKey='documentSummary'
            key={formKey}
            isUpdatable={false}
            inputTokenOptions={documentFieldMappingInputTokenOptions}
            onChange={onChange}
          />
        </Col>
      </Row>
      <Row className='mt-7'>
        <Col>
          <ContactLinking
            key={formKey}
            serviceId={serviceId}
            zocksObjectName={'Document Intelligence'}
            mappingPath='mappings.documentSummary'
            onChange={onChange}
          />
        </Col>
      </Row>
    </>
  )
}
